import { render } from "./DealerDetail.vue?vue&type=template&id=1a8e70ee&scoped=true&ts=true"
import script from "./DealerDetail.vue?vue&type=script&lang=ts"
export * from "./DealerDetail.vue?vue&type=script&lang=ts"

import "./DealerDetail.vue?vue&type=style&index=0&id=1a8e70ee&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a8e70ee"]])

export default __exports__